compiler('[disabled-unless-filled]', (element) => {
  const inputName = element.getAttribute('disabled-unless-filled');
  const inputs =   document.querySelectorAll(`[name="${inputName}"]`);

  function toggleDisabled() {
    let anyFilled = false
    inputs.forEach((input) => {
      if (input.type === 'checkbox' || input.type === 'radio') {
        if (input.checked) {
          anyFilled = true
        }
      } else {
        if (input.value !== '' && input.value !== null && input.value !== undefined) {
          anyFilled = true
        }
      }
    });
    element.disabled = !anyFilled
  }

  inputs.forEach((input) => {
    input.addEventListener('change', () => {
      toggleDisabled();
    });
  });

  toggleDisabled();
})
